<template>
    <v-content>
        <hero-page></hero-page>
        <about-me-page></about-me-page>
        <features-page></features-page>
        <experience-page></experience-page>
        <!--<blog-page></blog-page>-->
        <!--<contact-page></contact-page>-->
    </v-content>
</template>
<script>
import HeroComponent from './elements/HeroComponent.vue';
import AboutMeComponent from './elements/AboutMeComponent.vue';
import FeaturesComponent from './elements/FeaturesComponent.vue';
// import StatsComponent from './elements/StatsComponent.vue';
// import BlogComponent from './elements/BlogComponent.vue';
// import ContactComponent from './elements/ContactComponent.vue';
import ExperienceComponent from './elements/ExperienceComponent';
export default {
  name: 'App',
  components:{
    'hero-page':HeroComponent,
    'about-me-page':AboutMeComponent,
    'features-page':FeaturesComponent,
    // 'blog-page':BlogComponent,
    // 'contact-page':ContactComponent,
    'experience-page':ExperienceComponent
  },
  data: () => ({}),
  methods:{
    
  }
}
</script>
<style lang="scss" scoped>
  
</style>